export default "__VITE_ASSET__BcrmsFHx__"